import React from "react";
import { Skeleton } from "primereact/skeleton";

const SkeletonLoader = ({ type = "list", count = 3, height, width }) => {
  if (type === "card") {
    return (
      <div className="skeleton-grid">
        {[...Array(count)].map((_, i) => (
          <div key={i} className="skeleton-card">
            <Skeleton width="100%" height="200px" className="mb-2"></Skeleton>
            <div className="flex mb-2">
              <Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>
              <div style={{ flex: "1" }}>
                <Skeleton width="100%" className="mb-2"></Skeleton>
                <Skeleton width="75%"></Skeleton>
              </div>
            </div>
          </div>
        ))}
        <style jsx>{`
          .skeleton-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            gap: 20px;
            padding: 20px;
          }
          .skeleton-card {
            border: 1px solid #eee;
            border-radius: 8px;
            padding: 15px;
          }
          .mb-2 {
            margin-bottom: 0.5rem;
          }
          .mr-2 {
            margin-right: 0.5rem;
          }
          .flex {
            display: flex;
          }
        `}</style>
      </div>
    );
  }

  if (type === "text") {
    return (
      <div className="skeleton-text">
        {[...Array(count)].map((_, i) => (
          <Skeleton
            key={i}
            width={width || "100%"}
            height={height || "1rem"}
            className="mb-2"
          ></Skeleton>
        ))}
        <style jsx>{`
          .skeleton-text {
            padding: 10px;
          }
          .mb-2 {
            margin-bottom: 0.5rem;
          }
        `}</style>
      </div>
    );
  }

  // Default list
  return (
    <div className="skeleton-list">
      {[...Array(count)].map((_, i) => (
        <div key={i} className="skeleton-list-item mb-3">
          <Skeleton width="100%" height={height || "80px"}></Skeleton>
        </div>
      ))}
      <style jsx>{`
        .skeleton-list {
          padding: 20px;
        }
        .mb-3 {
          margin-bottom: 1rem;
        }
      `}</style>
    </div>
  );
};

export default SkeletonLoader;
